import { render, staticRenderFns } from "./중요변수들.vue?vue&type=template&id=0a0fc454&scoped=true&"
import script from "./중요변수들.vue?vue&type=script&lang=js&"
export * from "./중요변수들.vue?vue&type=script&lang=js&"
import style0 from "./중요변수들.vue?vue&type=style&index=0&id=0a0fc454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0fc454",
  null
  
)

export default component.exports